import { LexicalNode } from "lexical";

export function isParentAHeadingNode(node: LexicalNode) {
  const parent = node.getTopLevelElement();
  if (parent?.__type === "heading") {
    return true;
  }
  return false;
}
